/* eslint no-template-curly-in-string: 0 */
import { FLOW_TYPES, PAYMENT_NETWORKS } from '../../utils/enums';
import paypalLogo from '../../assets/images/logo-paypal.png';
import paypalCompleteImg from '../../assets/images/paypal-confirm.png';

export const paypalDash = {
  id: PAYMENT_NETWORKS.PAYPAL_DASH,
  displayName: 'PayPal',
  paywall: {
    tile: {
      displayName: 'PayPal',
      tagline: ['Delivered in 1-3 business days'],
      description: [
        {
          string: 'Funds sent to the account associated with your PayPal email address',
          type: 'div',
        },
      ],
      logo: paypalLogo,
    },
  },
  acceptPayment: {
    imgSrc: paypalLogo,
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.TWO_FACTOR,
    twoFactor: {
      type: 'email_address',
      getId: {
        description: [
          'Please enter the email address associated with your ',
          {
            string: '${paymentNetwork.displayName}',
            props: {
              className: 'payment-paymentNetwork',
            },
          },
          ' account.',
        ],
      },
      confirmId: {
        description: [
          'Verify your email address is correct and tied to your PayPal account. An error in your email address can result in a lost or non-recoverable payment.',
        ],
        confirmationText: [
          'I understand and confirm this is the correct email address for my PayPal account.',
        ],
      },
    },
    title: 'Receive with PayPal',
    description: [
      'Please enter the email address associated with your ',
      {
        string: '${paymentNetwork.displayName}',
        props: {
          className: 'payment-paymentNetwork',
        },
      },
      ' account.',
    ],
  },
  networkSelectionAccepted: {
    imgSrc: paypalCompleteImg,
    title: ['Success!'],
    description: [
      'Please check your email for details regarding your ',
      {
        string: '${paymentNetwork.displayName}',
        props: {
          className: 'payment-paymentNetwork',
        },
      },
      ' payment for ',
      {
        string: '${payment.acceptedAmount}',
        transformations: [
          {
            type: 'formatAsCurrency',
            data: {
              currency: '${payment.acceptedCurrency}',
            },
          },
        ],
        props: {
          className: 'payment-amount',
        },
      },
      '. It should arrive in 1-3 business days.',
    ],
    secondaryText: [
      'Your PayPal payment was sent to ',
      {
        string: '${payment.paymentNetworkRecipientId}',
        props: {
          className: 'payment-recipientEmail',
        },
      },
      '.'
    ],
  },
  paymentComplete: {
    initial: {
      description: [
        "Please check your email for details regarding your ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " payment for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: [
        'Your PayPal payment was sent to ',
        {
          string: '${payment.paymentNetworkRecipientId}',
          props: {
            className: 'payment-recipientEmail',
          },
        },
        '.'
      ]
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          "string": "${payment.recipientEmail}",
          "props": {
            "className": "payment-recipientEmail"
          }
        },
        " on ",
        {
          "string": "${payment.completedAt}",
          "props": {
            "className": "payment-updatedAt"
          },
          "transformations": [
            {
              "type": "formatDate"
            }
          ]
        },
        " with details regarding your PayPal payment for ",
        {
          "string": "${payment.acceptedAmount}",
          "transformations": [
            {
              "type": "formatAsCurrency",
              "data": {
                "currency": "${payment.acceptedCurrency}"
              }
            }
          ],
          "props": {
            "className": "payment-amount"
          }
        },
      ],
      secondaryText: [
        'Your PayPal payment was sent to ',
        {
          string: '${payment.paymentNetworkRecipientId}',
          props: {
            className: 'payment-recipientEmail',
          },
        },
        '.'
      ]
    },
    imgSrc: paypalCompleteImg,
  },
};

export default paypalDash;
